import React, { useMemo, lazy, useEffect } from 'react';
import { Routes, Route, Navigate, useLocation, useNavigate } from 'react-router-dom';

import GlobalStyles from 'theme/GlobalStyles';
import { checkMaintenanceDates } from 'utils/helper';

import { ROUTES, routesMapping } from './utils';
import Helmet from './Helmet';
import Layout from './Layout';
import SuspenseRoute from './SuspenseRoute';

const Home = lazy(() => import('pages/Home'));

const Root = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const isMaintenance = useMemo(() => checkMaintenanceDates(false, pathname), [pathname]);

  useEffect(() => {
    const route = routesMapping(pathname);

    if (isMaintenance && pathname !== '/maintenance' && (!route || route.isPrivate)) navigate('/maintenance');
  }, [isMaintenance, navigate, pathname]);

  return (
    <>
      <Helmet />
      <GlobalStyles />
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<SuspenseRoute component={Home} />} />
          {ROUTES.map(({ path, isPrivate, component }) => (
            <Route key={path} path={path} element={<SuspenseRoute component={component} isPrivate={isPrivate} />} />
          ))}
          <Route path="*" element={<Navigate to="/" />} />
        </Route>
      </Routes>
    </>
  );
};

export default Root;
